import ActionQueryInterpreter from "../../../../helpers/action-query-interpreter";

/**
 * @ngdoc object
 * @name theme.base.controller:HeaderCtrl
 *
 * @description
 *
 */

export default class NotificationBellController {
    constructor($location, $element, $transitions, Users, $uibModal, $auth, Alert, $http, $state, $timeout, $scope, $rootScope) {
        this.modal = $uibModal;
        this.auth = $auth;
        this.alert = Alert;
        this.api = $http;
        this.state = $state;
        this.scope = $scope;
        this.element = $element[0];
        this.rootScope = $rootScope;
        this.timeout = $timeout;
        this.unreadNotificationCount = 0;
        this.notifications = [];
        this.notificationReadQueue = {};
        this.actionInterpreter = new ActionQueryInterpreter(this.state);
        this.readDelay = 1000;
        this.pollInterval = 60000 * 5

        this.guestlistId = null;
        this.fetch = 'user';
        this.routeBase = ''
        this.interval = null;
        this.typeColors = {
            'default': {
                border: '#9c63ff',
                color: '#9c63ff'
            },
            'info': {
                border: '#9c63ff',
                color: '#9c63ff'
            },
            'warning': {
                border: '#f5b858',
                color: '#f5b858'
            },
            'danger': {
                border: '#e01249',
                color: '#e01249'
            },
            'success': {
                border: '#04cac3',
                color: '#04cac3'
            }
        };
        this.scrollHandler = () => {
        };
        this.onCloseTriggered = () => {
        };

    }

    $onInit() {
        this.buildBaseRoute();

        if (this.isInViewport(this.element)) {
            this.startFetching()
            return;
        }

        this.scrollHandler = () => {
            if (this.isInViewport(this.element)) {
                this.startFetching();
                window.removeEventListener('scroll', this.scrollHandler)
            }
        }

        window.addEventListener('scroll', this.scrollHandler);
    }

    fireCloseTrigger() {
        this.onCloseTriggered();
    }

    startFetching() {
        this.fetchUnreadNotificationCount();

        this.interval = setInterval(() => {
            this.fetchUnreadNotificationCount();
        }, this.pollInterval)
    }

    buildBaseRoute() {
        if (this.fetch === 'guestlist') {
            this.routeBase = 'notifications/guestlist/' + this.guestlistId + '/';
            return;
        }
        this.routeBase = 'notifications/';
    }


    $onDestroy() {
        window.removeEventListener('scroll', this.scrollHandler);
        clearInterval(this.interval);
    }

    isInViewport(element) {
        const {top, bottom} = element.getBoundingClientRect();
        const vHeight = (window.innerHeight || document.documentElement.clientHeight);

        return (
            (top > 0 || bottom > 0) &&
            top < vHeight
        );
    }

    fetchUnreadNotificationCount() {
        this.api.get(this.routeBase + 'unread/count')
            .then(({data}) => {
                this.unreadNotificationCount = data.data
            }).catch((error) => {

            if (error.status === -1) {
                return;
            }

            this.alert.error('Error', 'Error while fetching notifications. ' + error.status);
        })
    }

    fetchNotifications() {
        this.api.get(this.routeBase)
            .then(({data}) => {
                this.notifications = data.data
            }).catch((error) => {
            this.alert.error('Error', 'Error while fetching notifications');
        })
    }

    cancelMarkNotificationAsRead(index) {
        if (this.notificationReadQueue[this.notifications[index].id] === 'pending') {
            return;
        }

        if (this.notificationReadQueue[this.notifications[index].id] !== undefined) {
            clearTimeout(this.notificationReadQueue[this.notifications[index].id]);
        }
    }

    markNotificationAsReadHover(index) {
        if (this.notifications[index].read_at !== null) {
            return;
        }

        this.notificationReadQueue[this.notifications[index].id] = setTimeout(() => {
            this.notifications[index].read_at = (new Date()).toLocaleDateString();
            this.unreadNotificationCount -= 1;
            this.notificationReadQueue[this.notifications[index].id] = 'pending';

            this.api.post('notifications/' + this.notifications[index].id + '/read')
                .then(({data}) => {
                    this.notificationReadQueue[this.notifications[index].id] = undefined;
                    this.notifications[index] = data.data
                }).catch((error) => {
                this.unreadNotificationCount += 1;
                this.notificationReadQueue[this.notifications[index].id] = undefined;
                this.alert.error('Error', 'Error while fetching notifications');
            })
        }, this.readDelay);
    }

    markNotificationAsRead(index) {
        if (this.notifications[index].read_at !== null) {
            return;
        }


        return this.api.post('notifications/' + this.notifications[index].id + '/read')
            .then(({data}) => {
                this.notifications[index] = data.data
                this.unreadNotificationCount -= 1;
            }).catch((error) => {
                this.alert.error('Error', 'Error while fetching notifications');
            })

    }

    deleteNotification(index) {
        this.api.delete('notifications/' + this.notifications[index].id)
            .then(({data}) => {
                if (this.notifications[index].read_at === null) {
                    this.unreadNotificationCount -= 1;
                }

                this.notifications.splice(index, 1)
            }).catch((error) => {
            this.alert.error('Error', 'Error while fetching notifications');
        })
    }

    notificationStyle(notification) {
        let typeColors = this.typeColors[notification.data.type] || this.typeColors.default;
        if (!(!!notification.read_at)) {
            return {
                'border-color': typeColors.border,
                'color': typeColors.color,
                transition: 'all ' + this.readDelay + 'ms',

            };
        }
        return {
            'border-color': '#a9aeb8',
            'color': '#a9aeb8',
            transition: 'all ' + this.readDelay + 'ms',
        };
    }

    markAllNotificationsAsRead() {
        this.api.post(this.routeBase + 'read')
            .then(({data}) => {
                this.notifications = data.data
                this.unreadNotificationCount = 0;
            }).catch((error) => {
            this.alert.error('Error', 'Error while fetching notifications');
        })
    }

    executeAction(index) {
        this.markNotificationAsRead(index);
        this.actionInterpreter.execute(this.notifications[index].data.action);
    }

    deleteAllNotifications() {
        this.api.delete(this.routeBase)
            .then(({data}) => {
                this.notifications = []
                this.unreadNotificationCount = 0;
            }).catch((error) => {
            this.alert.error('Error', 'Error while fetching notifications');
        })
    }

}

NotificationBellController.$inject = [
    '$location',
    '$element',
    '$transitions',
    'Users',
    '$uibModal',
    '$auth',
    'Alert',
    '$http',
    '$state',
    '$timeout',
    '$scope',
    '$rootScope'];



// WEBPACK FOOTER //
// ./src/app/modules/core/components/al-notification-bell/controller.js